<div class="notification-banner" *ngIf="alert">
  <div class="container-fluid d-md-none">
    <div class="row align-items-center">
      <div class="col">
        <div class="mobile-sub-text d-md-none" [innerHtml]="alert.mobile_text"></div>
        <div class="btn mobile-notification-banner-close" (click)="closeOnMobile()">Close</div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="desktop-title d-none d-md-block" [innerHtml]="alert.text"></div>
    <div class="notification-banner-close" (click)="closeOnDesktop()">Close</div>
  </div>
</div>
